import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from "@mui/material/Button";
import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import ipahLogo from '_shared/_views/assets/attorney-hub-logo.svg';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router';
import backgroundImage from "_shared/_views/assets/login-background-laptop-coffee-notepad-phone-desk.jpg";
import EmailAddress from '_shared/email-addresses/email-address';
import Password from 'users/auth/credentials/passwords/password';
import UserCredentials from 'users/auth/credentials/user-credentials';
import Footer from '_shared/_views/footers/footer';
import AuthEmailAPIService from 'users/_api/auth-email-api-service';
import LoginForm from 'users/auth/_views/login-form';
import PasswordResetForm from 'users/auth/credentials/passwords/_views/password-reset-form';
import PasswordResetRequestForm from 'users/auth/credentials/passwords/_views/password-reset-request-form';

const MainContainer = styled(Grid)(() => ({
  height: '100vh'
}));
const ImageContainer = styled(Grid)(() => ({
  backgroundImage: `url(${backgroundImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundColor: 'gray',
  backgroundSize: 'cover',
  backgroundPosition: 'center'
}));
const FormContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: '#404558',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: '100vh',
  paddingBottom: theme.spacing(4),
  paddingLeft: '10%',
  paddingRight: '10%',
  [theme.breakpoints.down('lg')]: {
    paddingTop: '10%'
  },
  [theme.breakpoints.up("sm")]: {
    paddingTop: '20%'
  }
}));
const AttorneyHubLogo = styled('img')(({ theme }) => ({
  display: "flex",
  justifySelf: "center",
  marginBottom: theme.spacing(8),
  position: "sticky",
  top: 0,
  width: '90%'
}));
const ForgotPasswordButton = styled(Button)(() => ({
  display: "flex",
  justifySelf: "center",
  "&.MuiButton-root": {
    color: 'white'
  },
  "&.MuiButton-root:hover": {
    textDecoration: "none",
    backgroundColor: "rgba(255, 255, 255, 0.08)"
  }
}));

export default function LoginPage() {
  const [showPasswordReset, setShowPasswordReset] = React.useState(false);
  const [action, setAction] = React.useState<string | null>(null);
  const [userId, setUserId] = React.useState<string | null>(null);
  const [emailValue, setEmailValue] = React.useState<string | null>(null);
  const [token, setToken] = React.useState<string | null>(null);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    function handleQueryString() {
      setAction(searchParams.get('action'));
      setUserId(searchParams.get('userId'));
      setEmailValue(searchParams.get('email'));
      setToken(searchParams.get('token'));
    }
    handleQueryString();
  }, [searchParams]);

  async function handlePasswordReset(password: string) {
    if (!emailValue || !password) return;
    try {
      const credentials = new UserCredentials(new EmailAddress(emailValue), new Password(password));
      await AuthEmailAPIService.login(credentials, true);
      navigate('/dashboard', { replace: true });
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <MainContainer container>
        <ImageContainer size={{ sm: 4, lg: 7, xl: 8 }} />
        <Grid size={{ xs: 12, sm: 8, lg: 5, xl: 4 }} component={Paper} elevation={6} square>
          <FormContainer>
            <div style={{ width: '100%' }}>
              <AttorneyHubLogo src={ipahLogo} alt="IPAH logo" />
              {action !== 'confirm-password-reset' && (
                <>
                  {!showPasswordReset && <LoginForm onEmailValueChanged={setEmailValue} />}
                  {showPasswordReset && (
                    <>
                      <Typography variant="h4" align="center" style={{ color: 'white' }}>
                        Reset Password
                      </Typography>
                      <PasswordResetRequestForm emailValue={emailValue} />
                    </>
                  )}
                  <ForgotPasswordButton
                    size="small"
                    startIcon={showPasswordReset && <ArrowBackIcon />}
                    onClick={() => setShowPasswordReset(prevValue => (!prevValue))}>
                    {showPasswordReset ? 'Back To Login' : 'Forgot Password?'}
                  </ForgotPasswordButton>
                </>
              )}
              {action === 'confirm-password-reset' && (
                <>
                  <Typography variant="h4" color="textPrimary" align="center" style={{ color: 'white' }}>
                    Create New Password
                  </Typography>
                  <PasswordResetForm
                    userId={userId}
                    token={token}
                    onPasswordReset={handlePasswordReset} />
                </>
              )}
            </div>
            <Grid size={{ xl: 12 }}>
              <Footer mode='dark' />
            </Grid>
          </FormContainer>
        </Grid>
      </MainContainer>
    </React.Fragment>
  )
}
